import { Link } from 'react-router-dom';
import { Layout } from '@/components/feature/Layout';

export default function NotFound() {
  return (
    <Layout>
      <div className="pt-16">
        <div className="max-w-2xl mx-auto px-4 md:px-6 py-20 text-center">
          <div className="w-24 h-24 flex items-center justify-center mx-auto mb-8 bg-background-100 rounded-full">
            <i className="ri-error-warning-line text-4xl text-foreground-400"></i>
          </div>
          <h1 className="text-4xl font-heading font-bold text-foreground-900 mb-3">404</h1>
          <p className="text-lg text-foreground-700 mb-2 font-heading font-semibold">
            页面未找到
          </p>
          <p className="text-sm text-foreground-500 mb-8 max-w-sm mx-auto">
            您访问的页面不存在或已被移除。请检查网址是否正确，或返回首页。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-2.5 rounded-lg font-semibold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line mr-1.5"></i>
              返回首页
            </Link>
            <Link
              to="/about"
              className="border border-background-300 text-foreground-700 hover:bg-background-100 px-6 py-2.5 rounded-lg font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-customer-service-2-line mr-1.5"></i>
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}